import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Breadcrumb,
  Card,
  Col,
  Container,
  Row,
} from "react-bootstrap";

import {
  CustomPaging,
  EditingState,
  PagingState,
  SortingState,
  SearchState,
} from '@devexpress/dx-react-grid';

import {
  Grid,
  PagingPanel,
  Table,
  TableHeaderRow,
  TableEditColumn,
  Toolbar,
  SearchPanel
} from '@devexpress/dx-react-grid-bootstrap4';

import { Loading } from 'components/Loading/loading';
import PopupEditing from 'components/ReactTable/PopupEditing.js';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';
import Popup from './Popup.js';

export default function Index() {

  const [swal, setSwal] = useAlert();
  const [columns] = useState([
    { name: 'SCOPE_ID', title: 'ID' },
    { name: 'SCOPE_NAME', title: 'Scope Name' },
    { name: 'SCOPE_STATUS', title: 'Status' },
  ]);
  const [rows, setRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [pageSizes] = useState([5, 10, 15]);
  const [loading, setLoading] = useState(false);
  const [sorting, setSorting] = useState([{ columnName: 'SCOPE_ID', direction: 'asc' }]);
  const [searchValue, setSearchValue] = useState('');

  const commitChanges = async ({ added, changed, deleted }) => {

    try {

      if (added) {
        const newItem = {...added.pop()};
        const response = await axios.post(`${process.env.REACT_APP_API_HOST}scopes`, newItem);
        if (response.status !== 201) throw new Error(`Create new error`);
        return fetchData();
      }

      if (changed) {
        const id = Object.keys(changed).pop();
        const updatedItem = { ...changed[id] };
        const response = await axios.put(`${process.env.REACT_APP_API_HOST}scopes/${id}`, updatedItem);
        if (response.status !== 200) throw new Error('Update error');

        setSwal({
          type: TYPES.SUCCESS,
          payload: {
            title: `Scope successfuly updated`,
            message: ``,
          }
        });

        return fetchData();
      }

      if (deleted) {
        const item = rows.find(row => row.SCOPE_ID === [...deleted].pop());
        const onSuccessCallback = async () => {
          const response = await axios.delete(`${process.env.REACT_APP_API_HOST}scopes/${item.SCOPE_ID}`);
          if (response.status !== 204) throw new Error('Update error');
          return fetchData();
        }

        setSwal({
          type: TYPES.CONFIRM,
          payload: {
            title: `Are you sure`,
            message: `You are about to delete "${item.SCOPE_NAME}" scope.`,
            onSuccess: {
              title: `Success`,
              message: `Delete Success`,
              callback: onSuccessCallback,
            }
          }
        });
      }

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
     }

  };

  const getRowId = row => row.SCOPE_ID;

  const fetchData = async () => {

    setLoading(true);

    try {

      const orderBy = sorting?.[0];
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}scopes`, {
        params: {
          page: currentPage + 1,
          'per-page': pageSize,
          'search': searchValue,
          sort: `${orderBy?.direction === 'desc' ? '-' : ''}${orderBy?.columnName}`
        }
      });

      if (response.status !== 200) throw new Error(`Fetch error`);

      setRows(response.data.items);
      setTotalCount(response.data._meta.totalCount);
      setLoading(false);

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });

      setLoading(false);
    }
  }

  useEffect(fetchData, [searchValue, pageSize, currentPage, sorting]);

  return (
    <>
      {swal}
      <Container fluid>
        <Breadcrumb>
          <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
            Master
          </Breadcrumb.Item>
          <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
            Scope
          </Breadcrumb.Item>
          <Breadcrumb.Item aria-current="page" active>
            Index
          </Breadcrumb.Item>
        </Breadcrumb>

        {rows && (
          <Row>
            <Col md="12">
              <Card>
                <Card.Header>
                  <Card.Title as="h4">Scope List</Card.Title>
                </Card.Header>
                <Card.Body>
                  <Grid
                    rows={rows}
                    columns={columns}
                    getRowId={getRowId}
                  >
                    <SearchState onValueChange={setSearchValue} />
                    
                    <SortingState
                      sorting={sorting}
                      onSortingChange={setSorting}
                    />
                    <PagingState
                      currentPage={currentPage}
                      onCurrentPageChange={setCurrentPage}
                      pageSize={pageSize}
                      onPageSizeChange={setPageSize}
                    />
                    <CustomPaging totalCount={totalCount} />
                    <EditingState
                      onCommitChanges={commitChanges}
                    />
                    <Table />
                    <TableHeaderRow showSortingControls />
                    <TableEditColumn
                      showAddCommand
                      showEditCommand
                      showDeleteCommand
                    />
                    <PagingPanel
                      pageSizes={pageSizes}
                    />
                    <PopupEditing popupComponent={Popup} />
                    <Toolbar />
                    <SearchPanel />
                    {loading && <Loading />}
                  </Grid>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </>
  )
}